import { createTheme } from "@mui/material";
import { getPaletteOptions } from "./palette/index.js";
import { getTypography } from "./typography.js";
import { mixins } from "./mixins.js";
import { components } from "./component-overrides/index.js";
import { addGlobalStyles } from "./global-styles.js";
function getTheme(mode, applicationRoot) {
    const theme = createTheme({
        palette: getPaletteOptions(mode),
        typography: getTypography(),
        mixins: mixins,
        components: components
    });
    addGlobalStyles(theme, applicationRoot);
    return theme;
}
export { getTheme };

//# sourceMappingURL=theme.js.map